'use client'

import React, { useCallback } from 'react'
import { useTranslations } from 'next-intl'

import { HOLIDAYS_CONTACT } from '@/src/constants/holidays'
import useClevertapForHolidays from '@/src/hooks/analytics/clevertap/holidays'
import { HOLIDAY_ACTION, HOLIDAY_ACTION_TYPE } from '@/src/utils/analytics/holidays/holidayEvents'

import ContactStrip from './contactStrip'

/** `placement` on the contact event — the strip, as opposed to the form or the docked bar. */
const CONTACT_PLACEMENT = 'contact_strip'

interface ContactStripWrapperProps {
    /** `inline` only where the strip has the full content width. Defaults to the safe `stacked`. */
    layout?: 'inline' | 'stacked'
    isMobile: boolean
}

const ContactStripWrapper: React.FC<ContactStripWrapperProps> = ({ layout = 'stacked', isMobile }) => {
    const t = useTranslations('holidaysPage')
    const { triggerHolidayUIActionEvent } = useClevertapForHolidays()

    const handleContactClick = useCallback(() => {
        triggerHolidayUIActionEvent(HOLIDAY_ACTION.CONTACT_CLICKED, {
            action_type: HOLIDAY_ACTION_TYPE.CONTACT,
            channel: 'email',
            placement: CONTACT_PLACEMENT
        })
    }, [triggerHolidayUIActionEvent])

    return (
        <ContactStrip
            label={t('talkToExpert')}
            phoneLabel={HOLIDAYS_CONTACT.phoneLabel}
            emailAddress={HOLIDAYS_CONTACT.email}
            emailHref={`mailto:${HOLIDAYS_CONTACT.email}`}
            layout={layout}
            onContactClick={handleContactClick}
            isMobile={isMobile}
        />
    )
}

export { ContactStripWrapper }
export default ContactStripWrapper
